module.exports = __webpack_public_path__ + "media/stylesheets/images/media/service_folk-f1c8ae55f731fcc07f1efb7b41cd5c1c.png";